import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import type { DeleteListsProps } from './deleteListsApi';
import { deleteLists } from './deleteListsApi';
import { getGetListsQueryOptions } from '@vlabs/api/luna-api/client';

export function useDeleteLists(): UseMutationResult<void, TypeError, DeleteListsProps> {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation<void, TypeError, DeleteListsProps>({
    mutationFn: async ({
      listIds,
      action,
    }) => deleteLists({ listIds, action }),
    onError: (_, variables) => {
      queryClient.invalidateQueries(getGetListsQueryOptions());
      toast.error(t('features:delete_lists.toast.error', { count: variables.listIds.length }));
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(getGetListsQueryOptions());
      toast.success(t('features:delete_lists.toast.success', { count: variables.listIds.length }));
    },
  });
}
